<template>
    <div>
        <div class="panel-header panel-header-custom bg-primary-gradient">
            <div class="page-inner py-5">
                <div class="d-flex align-items-left align-items-md-center flex-column flex-md-row">
                    <div>
                        <h2 class="text-white pb-2 fw-bold">{{ $t("Заполняемость мест") }}</h2>
                    </div>
                </div>
            </div>
        </div>
        <div class="page-inner mt--5">
            <v-fade-transition mode="out-in">
                <div v-if="isLoading" key="occupancy-loader" aria-busy="true" aria-live="polite">
                    <v-row>
                        <v-col cols="12" md="3">
                            <v-card elevation="2">
                                <v-skeleton-loader
                                    type="heading"
                                    class="places-skeleton-loader acs-skeleton-heading"
                                ></v-skeleton-loader>
                                <v-card-text class="pt-0">
                                    <v-skeleton-loader
                                        v-for="n in 4"
                                        :key="'occupancy-filter-' + n"
                                        type="list-item-two-line, list-item, list-item, divider"
                                        class="places-skeleton-loader"
                                    ></v-skeleton-loader>
                                </v-card-text>
                            </v-card>
                        </v-col>
                        <v-col cols="12" md="9">
                            <v-card elevation="1" class="places-skeleton-card">
                                <v-skeleton-loader
                                    type="table-heading"
                                    class="places-skeleton-loader"
                                ></v-skeleton-loader>
                                <v-skeleton-loader
                                    v-for="n in 6"
                                    :key="'occupancy-skeleton-' + n"
                                    type="table-row-divider"
                                    class="places-skeleton-loader"
                                ></v-skeleton-loader>
                            </v-card>
                        </v-col>
                    </v-row>
                </div>
                <v-row v-else key="occupancy-content">
                    <v-col cols="12" md="3">
                        <v-card elevation="2">
                            <v-card-title class="card-title-custom">{{ $t('Фильтры') }}</v-card-title>
                            <v-card-text>
                                <v-radio-group v-model="filterPaymentType" @change="onFilterChange">
                                    <template v-slot:label>
                                        <div>{{ $t('Форма оплаты') }}</div>
                                    </template>
                                    <v-radio
                                        v-for="item in paymentType"
                                        :key="'payment-' + item.id"
                                        :label="item.name"
                                        :value="item.id"
                                        class="my-1">
                                    </v-radio>
                                </v-radio-group>
                                <v-divider></v-divider>
                                <v-radio-group v-model="filterTrainingType" @change="onFilterChange">
                                    <template v-slot:label>
                                        <div>{{ $t('Тип подготовки') }}</div>
                                    </template>
                                    <v-radio
                                        v-for="item in trainingType"
                                        :key="'training-' + item.id"
                                        :label="item.name"
                                        :value="item.id"
                                        class="my-1">
                                    </v-radio>
                                </v-radio-group>
                                <v-divider></v-divider>
                                <v-radio-group v-model="filterEducationType" @change="onFilterChange">
                                    <template v-slot:label>
                                        <div>{{ $t('Тип образования') }}</div>
                                    </template>
                                    <v-radio
                                        v-for="item in educationTypeList"
                                        :key="'education-type-' + item.id"
                                        :label="item.name"
                                        :value="item.id"
                                        class="my-1">
                                    </v-radio>
                                </v-radio-group>
                                <v-divider></v-divider>
                                <v-radio-group v-model="filterEducationForm" @change="onFilterChange">
                                    <template v-slot:label>
                                        <div>{{ $t('Форма обучения') }}</div>
                                    </template>
                                    <v-radio
                                        v-for="item in educationFormList"
                                        :key="'education-form-' + item.id"
                                        :label="item.name"
                                        :value="item.id"
                                        class="my-1">
                                    </v-radio>
                                </v-radio-group>
                            </v-card-text>
                        </v-card>
                    </v-col>
                    <v-col cols="12" md="9">
                        <v-data-table
                            :headers="placeHeaders"
                            :items="placeList"
                            hide-default-footer
                            :item-class="itemRowBackground"
                            :footer-props="{'items-per-page-options': [-1]}"
                            class="elevation-1 place-list">
                        </v-data-table>
                    </v-col>
                </v-row>
            </v-fade-transition>
        </div>
    </div>
</template>

<script>
    import {
        filterCollegeOccupancyList,
        getCollegeFilterOptions,
        getCollegeOccupancyHeaders,
        initializeCollegeOccupancyFilters,
        mapCollegeOccupancyList,
    } from '@/utils/college';

    export default {
        mounted() {
            this.getData();
        },
        data: () => ({
            isLoading: true,
            placeHeaders: [],
            placeList: [],
            allPlaceList: [],
            collegeMetadata: {},
            trainingType: [],
            paymentType: [],
            educationFormList: [],
            educationTypeList: [],
            filterPaymentType: null,
            filterTrainingType: null,
            filterEducationType: null,
            filterEducationForm: null,
        }),
        methods: {
            itemRowBackground(item) {
                if (+item.difference >= 0) {
                    return 'light-green lighten-4';
                }
                if (+item.difference < 0) {
                    return 'red lighten-5';
                }
                return '';
            },
            onFilterChange() {
                this.applyFilters();
            },
            applyFilters() {
                this.placeList = filterCollegeOccupancyList(this.allPlaceList, {
                    paymentType: this.filterPaymentType,
                    trainingType: this.filterTrainingType,
                    educationType: this.filterEducationType,
                    educationForm: this.filterEducationForm,
                });
            },
            loadFilterOptions() {
                const filterOptions = getCollegeFilterOptions(this.collegeMetadata);
                this.paymentType = filterOptions.paymentType;
                this.trainingType = filterOptions.trainingType;
                this.educationTypeList = filterOptions.educationTypeList;
                this.educationFormList = filterOptions.educationFormList;
            },
            async getData() {
                const showSkeleton = !this.placeHeaders.length;
                if (showSkeleton) {
                    this.isLoading = true;
                }

                try {
                    const [occupancyResponse, metadataResponse] = await Promise.all([
                        this.$http.get('/occupancy'),
                        this.$http.get('/metadata'),
                    ]);
                    this.collegeMetadata = (metadataResponse.data && metadataResponse.data.data)
                        || metadataResponse.data
                        || {};
                    this.loadFilterOptions();
                    this.placeHeaders = getCollegeOccupancyHeaders((key) => this.$t(key));

                    if (occupancyResponse.data && occupancyResponse.data.status) {
                        this.allPlaceList = mapCollegeOccupancyList(occupancyResponse.data.data);
                        const { placeList, filters } = initializeCollegeOccupancyFilters(this.allPlaceList, {
                            paymentType: this.filterPaymentType,
                            trainingType: this.filterTrainingType,
                            educationType: this.filterEducationType,
                            educationForm: this.filterEducationForm,
                        });
                        this.filterPaymentType = filters.paymentType;
                        this.filterTrainingType = filters.trainingType;
                        this.filterEducationType = filters.educationType;
                        this.filterEducationForm = filters.educationForm;
                        this.placeList = placeList;
                    } else {
                        this.allPlaceList = [];
                        this.placeList = [];
                    }
                } finally {
                    if (showSkeleton) {
                        this.isLoading = false;
                    }
                }
            },
        },
        watch: {
            '$store.state.language': function () {
                this.placeHeaders = getCollegeOccupancyHeaders((key) => this.$t(key));
            },
        },
    }
</script>

<style type="text/css" scoped src="@/assets/css/college/PlaceListView.css"></style>
